import { useState, useRef, useEffect } from 'react'
import { inject, observer } from 'mobx-react';
import { CommonService, UserService } from "../../../services";
import { createMultipleRef, validateInput, getValueInputRef, setOptions } from '../../../helpers'
import DataGrid, { SearchPanel, Toolbar, Item, Paging, Pager, Column, HeaderFilter } from 'devextreme-react/data-grid';
import { PlusIcon, RefreshIcon, CheckIcon } from '@heroicons/react/outline';
import { Form, Input, Button, Checkbox, Row, Col, Typography, Divider, Alert } from 'antd';
import {
  UserOutlined, MailOutlined, PhoneOutlined, LockOutlined, HomeOutlined, CheckCircleOutlined, CustomerServiceOutlined, LeftOutlined
} from '@ant-design/icons';
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'
import './style.css'

const { Title, Text, Link } = Typography;
const RegisterForm = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['register', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let { onBack } = props
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [billing, setBilling] = useState("monthly")
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log('Submit:', values);
  };


  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: []
    }
  })

  const [dataForm, setDataForm]: any = useState({
    "id": "",
    "employee_code": "",
    "username": "",
    "password": "",
    "first_name": "",
    "last_name": "",
    "email": "",
    "phone_no": "",
    "position": "",
    "user_status": "Y",
    "user_group_id": "",
    "role_level": ""
  })

  const gridRef: any = useRef(null);
  const inputRef: any = useRef([]);
  createMultipleRef(inputRef, 7)


  const tiers = [
    {
      name: 'PALMOTION',
      id: 'tier-enterprise',
      href: '#',
      priceMonthly: '฿399',
      description: 'Dedicated support and infrastructure for your company.',
      features: [
        'Unlimited products',
        'Unlimited subscribers',
        'Advanced analytics',
        'Dedicated support representative',
        'Marketing automations',
        'Custom integrations',
      ]
    },
    {
      name: 'PALMOTION PRO AI',
      id: 'tier-enterprise',
      href: '#',
      priceMonthly: '฿799',
      description: 'Dedicated support and infrastructure for your company.',
      features: [
        'Unlimited products',
        'Unlimited subscribers',
        'Advanced analytics',
        'Dedicated support representative',
        'Marketing automations',
        'Custom integrations',
      ]
    },
  ]


  const features = [
    {
      icon: <LockOutlined className="text-xl" />,
      title: "ปลอดภัย 100%",
      desc: "ข้อมูลของคุณได้รับการเข้ารหัส",
    },
    {
      icon: <CheckCircleOutlined className="text-xl" />,
      title: "ยกเลิกได้ทุกเมื่อ",
      desc: "ไม่มีข้อผูกมัดระยะยาว",
    },
    {
      icon: <CustomerServiceOutlined className="text-xl" />,
      title: "สนับสนุน 24/7",
      desc: "ทีมงานพร้อมให้ความช่วยเหลือ",
    },
  ];




  return (
    <>
      <div className="mt-5 md:col-span-2 md:mt-0 space-y-4">
        <div className="text-center space-y-4">
          <div className="mx-auto max-w-4xl">
            <p className="mt-2 text-3xl font-semibold tracking-tight text-balance">
              {t('register_title')}
            </p>
          </div>
          <p className="mx-auto mt-2 max-w-xl text-lg text-gray-700 font-medium text-pretty sm:text-xl/8">
            {t('register_desc')}
          </p>

          <div
            role="tablist"
            aria-label="Billing period"
            className="inline-flex items-stretch rounded-full border register-border overflow-hidden bg-white"
          >
            <button
              role="tab"
              aria-selected={billing === "monthly"}
              onClick={() => setBilling('monthly')}
              className={`px-6 py-2 text-sm font-medium transition-colors duration-150 rounded-l-full w-36 ${billing === "monthly" ? "register-btn-bg text-white" : "text-gray-800 hover:bg-red-50"}`}
            >
              {t('resiter.individual')}
            </button>
            <div className="w-px bg-red-700" />
            <button
              role="tab"
              aria-selected={billing === "yearly"}
              onClick={() => setBilling("yearly")}
              className={`px-6 py-2 text-sm font-medium transition-colors duration-150 rounded-r-full w-36 ${billing === "yearly" ? "register-btn-bg text-white" : "text-gray-800 hover:bg-red-50"}`}
            >
              {t('resiter.corporation')}
            </button>
          </div>
        </div>

        <div
          className="mx-auto grid max-w-lg items-center lg:max-w-xl cursor-pointer text-black font-semibold hover:underline"
          onClick={() => onBack()}
        >
          <div className="space-x-2">
            <LeftOutlined className="text-xs" />
            <span>กลับไปเลือกแผน</span>
          </div>

        </div>

        <div className="mx-auto grid max-w-lg grid-cols-1 items-center gap-x-6  sm:gap-y-0 lg:max-w-xl lg:grid-cols-1">
          <div className="bg-white rounded-3xl p-8 register-border sm:p-10">
            <Title level={3} className="mb-0">ข้อมูลการสมัครสมาชิก</Title>
            <Text className="text-gray-500">กรอกข้อมูลของคุณเพื่อสร้างบัญชี</Text>
            <Divider className="bg-black" />

            <Form
              form={form}
              layout="vertical"
              size="large"
              onFinish={onFinish}
              className="mt-10"
            >
              {/* ชื่อ-นามสกุล */}
              <Form.Item
                label="ชื่อ-นามสกุล"
                name="fullName"
                rules={[{ required: true, message: 'กรุณากรอกชื่อ-นามสกุล' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="การกรอกชื่อ - นามสกุลของคุณ"
                  allowClear
                />
              </Form.Item>

              {/* อีเมล */}
              <Form.Item
                label="อีเมล"
                name="email"
                rules={[
                  { required: true, message: 'กรุณากรอกอีเมล' },
                  { type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง' },
                ]}
              >
                <Input
                  prefix={<MailOutlined />}
                  placeholder="example@gmail.com"
                  allowClear
                />
              </Form.Item>

              {/* เบอร์โทร */}
              <Form.Item
                label="เบอร์โทร"
                name="phone"
                rules={[
                  { required: true, message: 'กรุณากรอกเบอร์โทร' },
                  { pattern: /^[0-9\-+ ]{8,20}$/, message: 'รูปแบบเบอร์โทรไม่ถูกต้อง' },
                ]}
              >
                <Input
                  prefix={<PhoneOutlined />}
                  placeholder="086-000-1234"
                  allowClear
                />
              </Form.Item>

              {/* รหัสผ่าน */}
              <Form.Item
                label="รหัสผ่าน"
                name="password"
                rules={[
                  { required: true, message: 'กรุณากรอกรหัสผ่าน' },
                  { min: 8, message: 'รหัสผ่านอย่างน้อย 8 ตัวอักษร' },
                ]}
                extra="รหัสผ่านต้องมีตัวอักษรใหญ่ 1 และ ตัวเลข 1"
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="สร้างรหัสผ่านของคุณ"
                // iconRender={visible => (visible ? <LockOutlined /> : <LockOutlined />)}
                />
              </Form.Item>

              {/* ยืนยันรหัสผ่าน */}
              <Form.Item
                label="ยืนยันรหัสผ่าน"
                name="confirm"
                dependencies={['password']}
                rules={[
                  { required: true, message: 'กรุณายืนยันรหัสผ่าน' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) return Promise.resolve();
                      return Promise.reject('รหัสผ่านไม่ตรงกัน');
                    },
                  }),
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="ยืนยันรหัสผ่านของคุณอีกครั้ง"
                />
              </Form.Item>

              {/* ที่อยู่ */}
              <Form.Item label="ที่อยู่" name="address"
                rules={[{ required: true, message: 'กรุณากรอกที่อยู่' }]}
              >
                <Input
                  prefix={<HomeOutlined />}
                  placeholder="บ้านเลขที่ ซอย ถนน"
                />
              </Form.Item>

              <Row gutter={12}>
                <Col span={8}>
                  <Form.Item name="subdistrict" label="แขวง/ตำบล"
                    rules={[{ required: true, message: 'กรุณากรอกแขวง/ตำบล' }]}
                  >
                    <Input placeholder="แขวง/ตำบล" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="district" label="เขต/อำเภอ"
                    rules={[{ required: true, message: 'กรุณากรอกเขต/อำเภอ' }]}
                  >
                    <Input placeholder="เขต/อำเภอ" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="zipcode" label="รหัสไปรษณีย์"
                    rules={[
                      { required: true, message: 'กรุณากรอกรหัสไปรษณีย์' },
                      { pattern: /^[0-9]{5}$/, message: 'รหัสไปรษณีย์ 5 หลัก' },
                    ]}
                  >
                    <Input placeholder="xxxxx" maxLength={5} />
                  </Form.Item>
                </Col>
              </Row>

              {/* ยอมรับเงื่อนไข */}
              <Form.Item
                name="accept"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, v) => v ? Promise.resolve() : Promise.reject('กรุณายอมรับเงื่อนไขการสมัครสมาชิก'),
                  },
                ]}
              >

                <div className="ring-1 ring-gray-200 bg-gray-100 p-2 rounded-md">
                  <Checkbox>
                    <div className="tw-flex tw-flex-col">
                      <Text strong>ฉันยอมรับข้อกำหนดและเงื่อนไข</Text><br />
                      <Text type="secondary" className="tw-text-sm tw-leading-snug">
                        โดยการสมัครสมาชิก คุณยอมรับ{' '}
                        <Link target="_blank">
                          ข้อกำหนดการใช้งาน
                        </Link>{' '}
                        และ{' '}
                        <Link target="_blank">
                          นโยบายความเป็นส่วนตัว
                        </Link>{' '}
                        ของเรา
                      </Text>
                    </div>
                  </Checkbox>
                </div>
              </Form.Item>

              {/* แคมเปญที่เลือก */}
              {/* <div className="campaign-text">แคมเปญที่เลือก : PALMOTION</div> */}

              <div className="mb-6">
                <Alert message={`แผนที่เลือก : PALMOTION`} type="success" style={{ height: 50 }} />
              </div>

              <div className="flex justify-center text-center space-y-4">
                <button
                  type="submit" className="register-btn-bg text-white hover:bg-red-600  block rounded-full px-3.5 py-2.5 text-center text-sm font-semibold w-96"
                >
                  {t('สมัครสมาชิก')}
                </button>
              </div>

              <div className="flex flex-row items-center justify-center gap-10">
                <Text type="secondary">มีบัญชีอยู่แล้ว?</Text>
                <Button type="link" className="p-0 font-semibold text-black">
                  เข้าสู่ระบบ
                </Button>
              </div>
            </Form>
          </div>
        </div>

        <div className="flex justify-center items-start gap-16 mt-10 text-center">
          {features.map((item, i) => (
            <div key={i} className="max-w-[200px] flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-700 mb-3">
                {item.icon}
              </div>
              <h3 className="text-base font-semibold text-black mb-1">{item.title}</h3>
              <p className="text-sm text-gray-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
      {/* <ModalAlert
        {...optionAlert}
        onOk={() => {
          let { action } = optionAlert
          if (["create", "update"].includes(action.name))
            saveData()
          else if (action.name === "delete")
            deleteUser(action.id)
          else if (action.name === "reset-pass")
            resetPassword(action.id)

          setOptionAlert(setOptions({
            defaultOption: alert,
            show: false
          }))
        }}
        onCancel={() => {
          setOptionAlert(setOptions({
            defaultOption: alert,
            show: false
          }))
        }}
      /> */}
    </>
  )
}))

export default RegisterForm